import React from 'react';
import {
  Route,
  Switch,
} from 'react-router-dom';

import ClaimDetails from '@routes/Case/Claims/ClaimDetails/ClaimDetails';
import ClaimsList from '@routes/Case/Claims/ClaimsList/ClaimsList';

const Claims = () => (
  <Switch>
    <Route path="/cases/:caseId/claims/:claimId" component={ClaimDetails} />
    <Route path="/cases/:caseId/claims" component={ClaimsList} />
  </Switch>
);

export default Claims;



// WEBPACK FOOTER //
// ./src/routes/Case/Claims/Claims.js